module.exports = __webpack_public_path__ + "img/order.2608a6d0.png";